<template>
  <v-form ref="form" @submit.prevent="submit">
    <v-text-field
      v-model="company.name"
      :rules="[required]"
      label="Company Name"
      validate-on-blur
    />
    <v-text-field
      v-model="company.address"
      :rules="[required]"
      label="Company Address"
      validate-on-blur
    />
    <v-text-field
      v-model="company.phone"
      :rules="[required]"
      label="Company Phone"
      validate-on-blur
    />
    <v-checkbox v-model="types.single" label="Single Unit" />
    <v-checkbox v-model="types.multi" label="Multi Unit" />
    <v-checkbox v-model="types.commercial" label="Commercial Apartments" />
    <v-text-field
      v-model="name"
      label="Full Name"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="phone"
      label="Phone Number"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.type"
      label="Type of Bank Account"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.routing"
      label="Bank Account Routing Number"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.number"
      label="Bank Account Number"
      :rules="[required]"
      validate-on-blur
    />
    <v-btn type="submit">
      Update
    </v-btn>
  </v-form>
</template>

<script>
import { getUid, db } from '@/plugins/firebase';
import { required } from '@/util';

export default {
  name: 'AdminDetails',
  data: () => ({
    company: {
      name: '',
      address: '',
      phone: '',
    },
    types: {
      single: false,
      multi: false,
      commercial: false,
    },
    name: '',
    phone: '',
    bank: {
      type: '',
      routing: '',
      number: '',
    },
  }),
  async created() {
    const user = await db
      .collection('users')
      .doc(getUid())
      .get();
    Object.assign(this, user.data());
  },
  methods: {
    required,
    async submit() {
      if (!this.$refs.form.validate()) return;
      await db
        .collection('users')
        .doc(getUid())
        .set(this.$data, { merge: true });
    },
  },
};
</script>
